import { render, staticRenderFns } from "./CBT.vue?vue&type=template&id=5d99ce2e&scoped=true&"
import script from "./CBT.vue?vue&type=script&lang=js&"
export * from "./CBT.vue?vue&type=script&lang=js&"
import style0 from "./CBT.vue?vue&type=style&index=0&id=5d99ce2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99ce2e",
  null
  
)

export default component.exports